import Joi from 'joi';
import api from '../../api';
import { localeSchema } from '../schemas';

/**
 * Get all locales
 * @returns {Promise<{data: Locale[], default: string}>}
 */
export const getAlllocales = async () => {
  const result = await api.get('/content-management/v1-0/admin/locales');

  try {
    const schema = Joi.object({
      data: Joi.array().items(localeSchema).required(),
      default: Joi.string().required(),
    });
    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new Error(`API response do not match All Locales Schema : ${error.message}`);
  }

  return result.data;
};
